import { Button, Form, Input, message } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { postRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { LoadingView } from "../common";
import backBtn from "../../assets/images/back-arrow.svg";
import poweredLogo from "../../../src/assets/images/PoweredNew.png";
import "./ChangePassword.scss";

function ChangePassword() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  sessionStorage.setItem("page", "changepwd");
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");

  const onFinish = async (values) => {
    if (values.newPassword === values.confirmPwd) {
      delete values.confirmPwd;
      try {
        setLoading(true);
        const response = await postRequest(
          userServiceApi.changePassword(),
          values
        );
        setLoading(false);
        if (response === "success") {
          message.success("Password Updated Successfully");
          setTimeout(()=>{
            sessionStorage.clear();
            window.location.reload();
          },300)
          // if (token) {
          //   navigate("/admin");
          // } else {
          //   navigate("SuperAdmin");
          // }
        }
      } catch (error) {
        setLoading(false);
        toast.error(error.error || "Something went wrong");
      }
    } else {
      toast.error("Password and Confirm Password do not match");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  if (loading) return <LoadingView message="Loading..." />;

  return (
    <div className="changepassword-page">
      <div className="header-left" onClick={() => navigate(-1)}>
        <img src={backBtn} alt="back-button" />
        <p>Change password</p>
      </div>

      {/* Form container */}
      <div className="changePwdContainer">
        <Form
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          labelAlign="left"
          labelCol={{ style: { paddingRight: "90px" } }}
        >
          <Form.Item
            label="Old Password : "
            name="currentPassword"
            rules={[
              { required: true, message: "Please input your old password!" },
            ]}
          >
            <Input.Password
              placeholder="Old Password"
              iconRender={(visible) =>
                visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>

          <Form.Item
            label="New Password : "
            name="newPassword"
            hasFeedback
            rules={[
              { required: true, message: "Please input your new password" },
              {
                min: 8,
                message: "Password must be at least 8 characters long",
              },
              {
                pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
                message:
                  "Password must include uppercase, lowercase, number, and special character",
              },
            ]}
          >
            <Input.Password placeholder="New Password" />
          </Form.Item>

          <Form.Item
            label="Confirm Password : "
            name="confirmPwd"
            dependencies={["newPassword"]}
            hasFeedback
            rules={[
              { required: true, message: "Please input your confirm password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match"));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm Password" />
          </Form.Item>

          <div className="pwdUpdateBtn">
            <Button className="clear-btn addhelpClear" onClick={() => navigate("/admin")}>
              Cancel
            </Button>
            <Button className="sendBtn" htmlType="submit">
              Update
            </Button>
          </div>
        </Form>
      </div>

      {/* Footer logo */}
      <div className="footerlogo">
        <img src={poweredLogo} alt="powered-logo" />
      </div>
    </div>
  );
}

export default ChangePassword;
